module.exports = __webpack_public_path__ + "static/17-dfd5bc55d42034b8cac181e9286924e8.png";